import type { ReactNode } from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '~/lib/utils'

const bannerVariants = cva('rounded-md px-3 py-2 text-sm', {
    variants: {
        tone: {
            error: 'bg-point-subtle text-destructive',
            success: 'bg-success-subtle text-success',
            warning: 'bg-warning-subtle text-warning',
        },
    },
    defaultVariants: { tone: 'error' },
})

export interface ErrorBannerProps extends VariantProps<typeof bannerVariants> {
    children: ReactNode
    className?: string
}

/** 화면 공통 알림 배너. 인라인 복붙 대신 이 컴포넌트를 쓴다(에러/성공/경고 톤). */
export function ErrorBanner({ children, tone, className }: ErrorBannerProps) {
    if (!children) return null
    return (
        <div className={cn(bannerVariants({ tone }), className)} role='alert'>
            {children}
        </div>
    )
}
